import React from 'react';
import moment from 'moment';
import {colors} from 'style';

var s= {
    time:{
        fontSize: '1.2em',
        color: colors.themeMaroon,
    }
};

const DigitalTimer = ({time, formatStr='HH:mm:ss.SSS', style}) => (
        <div style={{...s.time, ...style}}>{moment.utc(time).format(formatStr)}</div>
);

export default DigitalTimer;



// WEBPACK FOOTER //
// ./src/modules/challenges/types/DigitalTimer.js